export default {
  id: null,
  cc: [],
  to: [],
  bcc: [],
  subject: "",
  body: "",
  sendMeCopy: false,
};
